import { useState } from 'react';
import { AddressableViewLayout } from 'framework/ViewTypes';
import { bindCollection } from 'framework/ViewTypes/contentLayout';
import CreateVendorRequestDrawer from '../createupdate/Create/CreateVendorRequestDrawer';
import { useVendorsUrl } from '../routes';
import { getVendorsTableConfig } from './vendorsTableConfig';
import useVendorsCollection from './useVendorsCollection';
import useVendorsFilterBar from './useVendorsFilterBar';

const VendorsListPage = () => {
  const [isCreateDrawerOpen, setCreateDrawerOpen] = useState(false);
  const { getSingleEntityUrl } = useVendorsUrl();
  const collection = useVendorsCollection();
  const { searchProps, filterProps } = useVendorsFilterBar(collection);

  const binding = bindCollection(
    collection,
    getVendorsTableConfig(collection.rows, getSingleEntityUrl, {
      onCreate: () => setCreateDrawerOpen(true),
    }),
    { searchProps, filterProps },
  );

  return (
    <AddressableViewLayout
      title="Vendors"
      drawer={
        <CreateVendorRequestDrawer
          isOpen={isCreateDrawerOpen}
          onClose={() => setCreateDrawerOpen(false)}
          onSuccess={collection.reload}
        />
      }
      {...binding.pageProps}
    />
  );
};

export default VendorsListPage;
